import { createSimpleThemedComponent } from '../util/createThemedComponent';
export var TextField = createSimpleThemedComponent({
    as: 'input',
    variant: 'default',
    themeKey: 'textFields',
    sx: {
        appearance: 'none',
        fontSize: 2,
        color: 'text',
        outline: 'none',
    },
});
//# sourceMappingURL=TextField.js.map